const strings = {
	en: {
		title: 'Privacy Policy',
	},
	es: {
		title: 'Política de privacidad',
	}
}

export default strings;